import { render } from "./InquiryDetail_client.vue?vue&type=template&id=77c487a8"
import script from "./InquiryDetail_client.vue?vue&type=script&lang=js"
export * from "./InquiryDetail_client.vue?vue&type=script&lang=js"

import "./InquiryDetail_client.vue?vue&type=style&index=0&id=77c487a8&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__